<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Wallet</p>
      <b-button type="button" icon-left="close" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <p class="mb-5">Do not deposit any other crypto than the selected wallet. Deposits will mostly arrive within 30 minutes.</p>

      <div class="row columns is-mobile">
        <div class="column is-4">
          <figure class="image is-16x16">
            <img src="../assets/btc.png" />
          </figure>
          <span class="ml-2">Bitcoin</span>
        </div>
        <div class="column is-justify-content-center">
          {{ getWalletBalance('btc').usableBalance }}
        </div>
        <div class="column is-5 is-justify-content-end">
          <b-button v-if="wallet.type !== 'btc'" @click="showWalletAddress('btc')" type="is-success" size="is-small" :loading="loading == 'btc'">Deposit</b-button>
          <b-button v-if="wallet.type !== 'btc'" @click="withdraw()" type="is-dark" size="is-small" :loading="loading == 'btc'" class="ml-2">Withdraw</b-button>
          <b-input v-else icon="content-copy" size="is-small" class="hoverable" icon-clickable @icon-click="copyAddress(wallet.address)" :value="wallet.address" />
        </div>
      </div>
      <div class="row columns is-mobile">
        <div class="column is-4">
          <figure class="image is-16x16">
            <img src="../assets/eth.png" />
          </figure>
          <span class="ml-2">Ethereum</span>
        </div>
        <div class="column is-justify-content-center">
          {{ getWalletBalance('eth').usableBalance }}
        </div>
        <div class="column is-5 is-justify-content-end">
          <b-button v-if="wallet.type !== 'eth'" @click="showWalletAddress('eth')" type="is-success" size="is-small" :loading="loading == 'eth'">Deposit</b-button>
          <b-button v-if="wallet.type !== 'eth'" @click="withdraw()" type="is-dark" size="is-small" :loading="loading == 'btc'" class="ml-2">Withdraw</b-button>
          <b-input v-else icon="content-copy" size="is-small" class="hoverable" icon-clickable @icon-click="copyAddress(wallet.address)" :value="wallet.address" />
        </div>
      </div>
      <div class="row columns is-mobile">
        <div class="column is-4">
          <figure class="image is-16x16">
            <img src="../assets/doge.png" />
          </figure>
          <span class="ml-2">Doge</span>
        </div>
        <div class="column is-justify-content-center">
          {{ getWalletBalance('doge').usableBalance }}
        </div>
        <div class="column is-5 is-justify-content-end">
          <b-button v-if="wallet.type !== 'doge'" @click="showWalletAddress('doge')" type="is-success" size="is-small" :loading="loading == 'doge'">Deposit</b-button>
          <b-button v-if="wallet.type !== 'doge'" @click="withdraw()" type="is-dark" size="is-small" :loading="loading == 'btc'" class="ml-2">Withdraw</b-button>
          <b-input v-else icon="content-copy" size="is-small" class="hoverable" icon-clickable @icon-click="copyAddress(wallet.address)" :value="wallet.address" />
        </div>
      </div>
      <div class="row columns is-mobile">
        <div class="column is-4">
          <figure class="image is-16x16">
            <img src="../assets/ltc.png" />
          </figure>
          <span class="ml-2">Litecoin</span>
        </div>
        <div class="column is-justify-content-center">
          {{ getWalletBalance('ltc').usableBalance }}
        </div>
        <div class="column is-5 is-justify-content-end">
          <b-button v-if="wallet.type !== 'ltc'" @click="showWalletAddress('ltc')" type="is-success" size="is-small" :loading="loading == 'ltc'">Deposit</b-button>
          <b-button v-if="wallet.type !== 'ltc'" @click="withdraw()" type="is-dark" size="is-small" :loading="loading == 'btc'" class="ml-2">Withdraw</b-button>
          <b-input v-else icon="content-copy" size="is-small" class="hoverable" icon-clickable @icon-click="copyAddress(wallet.address)" :value="wallet.address" />
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
    </footer>
  </div>
</template>
<script>
import ApiService from '../common/api.service'
import Withdraw from './Withdraw.vue'

export default {
  data() {
    return {
      loading: null,
      wallet: {
        type: null,
        address: null
      },
    }
  },
  methods: {
    showWalletAddress(type) {
      this.wallet = this.wallets.find((wallet) => { return wallet.type == type })
    },
    async copyAddress(address) {
      await navigator.clipboard.writeText(address)
      
      this.$buefy.toast.open({
        type: "is-success",
        message: "Copied to clipboard"
      })
    },
    getWalletBalance(type) {
      return this.wallets.find((wallet) => { return wallet.type == type })
    },
    withdraw() {
      this.$emit('close')
      this.$buefy.modal.open({
        parent: this,
        component: Withdraw,
        hasModalCard: true,
        trapFocus: true
      })
    }
  },
  computed: {
    wallets() {
      return this.$store.state.user.wallets
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  max-width: 800px;
  padding: 10px;
  margin: 0 auto !important;
  .modal-card-body {
    padding: 30px;
  }
}
.row {
  padding: 7px 15px;
  border-radius: 5px;
  font-size: 0.9rem;
  &:nth-child(2n + 1) {
    background: #141518
  }
  .column {
    display: flex;
    align-items: center;
  }
}
</style>
